import * as React from "react";

import Link from "next/link";
import { Button, SxProps, Theme } from "@mui/material";

const LinkButton: React.FC<{ sx?: SxProps<Theme>; children: React.ReactNode; href: string }> = ({
  sx,
  children,
  href,
}) => {
  return (
    <Link href={href}>
      <Button
        sx={{
          textTransform: "initial",
          fontWeight: 500,
          p: "6px 12px",
          bgcolor: "primary.main",
          color: "#fff",
          gap: "6px",
          "&:hover": {
            bgcolor: "#5900FF",
            color: "#fff",
          },
          ...sx,
        }}
      >
        {children}
      </Button>
    </Link>
  );
};

export default LinkButton;
